<div *ngIf="!isOpened">
  <div class="row px-1">
    <div class="only-button d-flex justify-content-end container-style">
      <app-custom-button class="button-new-register" [width]="'5rem'" [title]="'Nuevo'" [label]="'Nuevo'"
        [severity]="'success'" [variant]="undefined" [icon]="'pi pi-plus'" [width]="'5.5rem'"
        (onClick)="openModalTypeInventory()"></app-custom-button>
      <app-custom-modal #typeInventoryModal [label]="'Captura Tipo Inventario'" [header]="'Captura Tipo Inventario'"
        [children]="componentRegisterTypeInventory" [inputs$]="inputsForTypeInventory$" [width]="'30vw'"
        [output$]="inputsForTypeInventory$" hidden></app-custom-modal>
    </div>
  </div>
  <div class="container-style">
    <app-custom-table [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
      [previousFilters]="filters" [filterPersistentKey]="url" (onRecoverData)="getTypeInventoriesForConsultation()"
      (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>